import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/layout'
import Login from '@/views/Login'
import platformHome from '@/views/Works/platformHome'
import BranchHome from '@/views/Works/BranchHome'
import RankingLeader from '@/views/Works/Ranking/Leader'
import RankingBranch from '@/views/Works/Ranking/Branch'
import Home from '@/views/Home'
import Works from '@/views/Works'
import Branch from '@/views/Branch'
import Management from '@/views/Management'
import MailList from '@/views/MailList'
import DataBank from '@/views/DataBank'
import RoutesGroup from './RoutesGroup'
import screenbox from "@/views/Works/platformHome/components/screenbox"
Vue.use(Router)
export const fixedRouter = [
  //登陆页面
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    name: 'Web',
    path: '/Web',
    component: () => import('@/views/web'),
  },
  // 党委智慧屏
  {
    name: 'platformHome',
    path: '/Works/platformHome',
    component: platformHome
  },
  {
    name: 'Menus',
    path: '/Works/platformHome/Menus',
    component: () => import('@/views/Works/platformHome/Menus'),
  },
  //党委智慧屏内部
  {
    name: 'Team',
    path: '/Works/platformHome/Team',
    component: screenbox,
    children: [{
      name: 'Team',
      path: '/Works/platformHome/Team',
      component: () => import('@/views/Works/platformHome/Team'),
      meta: {
        setIndex: "1",
        title: "数据可视化"
      }
    },
    {
      name: 'BasicInfo',
      path: '/Works/platformHome/BasicInfo',
      component: () => import('@/views/Works/platformHome/BasicInfo'),
      meta: {
        setIndex: "2",
        title: "数据可视化"
      }
    }, {
      name: 'Achievement',
      path: '/Works/platformHome/Achievement',
      component: () => import('@/views/Works/platformHome/Achievement'),
      meta: {
        setIndex: "3",
        title: "数据可视化"
      }
    }, {
        name: 'Interconnection',
        path: '/Works/platformHome/Interconnection',
        component: () => import('@/views/Works/platformHome/Interconnection'),
        meta: {
          setIndex: "5",
          title: "数据可视化"
        }
      }]
  },
  // 支部智慧屏
  {
    name: 'BranchHome',
    path: '/Works/BranchHome',
    component: BranchHome
  },
  // 党委积分排名
  {
    name: 'RankingLeader',
    path: '/Works/Ranking/Leader',
    component: RankingLeader
  },
  // 支部积分排名
  {
    name: 'RankingBranch',
    path: '/Works/Ranking/Branch',
    component: RankingBranch
  },
  //首页
  {
    path: '/',
    component: layout,
    children: [{
      name: 'Home',
      path: '/Home',
      component: Home,
      meta: {
        setIndex: "Home",
        title: "首页"
      }
    }]
  },
  //忘记密码
  {
    path: '/ForgotPassword',
    component: layout,
    children: [{
      name: 'ForgotPassword',
      path: '/ForgotPassword',
      component: () => import('@/views/ForgotPassword'),
      meta: {
        setIndex: 1,
        title: "忘记密码"
      }
    }]
  },
  // 未注册手机号前往注册手机
  {
    path: '/registration',
    component: layout,
    children: [{
      name: 'registration',
      path: '/registration',
      component: () => import('@/views/registration'),
      meta: {
        setIndex: "Home",
        title: "手机号注册"
      },
    }]
  },


  // 工作台
  {
    path: '/',
    component: layout,
    children: [{
      name: 'Works',
      path: '/Works',
      component: Works,
      meta: {
        title: '工作台',
        setIndex: "Works",
        moudles: true
      },
      children: [
        // 荣誉管理
        {
          name: "HonorWall",
          path: 'HonorWall',
          meta: {
            setIndex: "Works",
            subname: 'HonorWall',
            title: "党组织及党员荣誉墙",
            content: RoutesGroup.HonorWallName
          },
          component: () => import('@/views/Works/HonorWall'),
        },
        // 党员荣誉积分明细
        {
          name: "PersonHonor",
          path: 'PersonHonor',
          meta: {
            setIndex: "Works",
            subname: 'PersonHonor',
            title: "党员荣誉积分明细",
            content: RoutesGroup.HonorWallName
          },
          component: () => import('@/views/Works/HonorWall/PersonHonor'),
        },
        // 党组织荣誉加分表
        {
          name: "OrgHonor",
          path: 'OrgHonor',
          meta: {
            setIndex: "Works",
            subname: 'OrgHonor',
            title: "党组织荣誉加分表",
            content: RoutesGroup.HonorWallName
          },
          component: () => import('@/views/Works/HonorWall/OrgHonor'),
        },
        //会议管理开始
        {
          name: "CreatMeeting",
          path: 'MeetingsManage/CreatMeeting',
          meta: {
            setIndex: "Works",
            subname: 'CreatMeeting',
            title: "创建会议",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingsManage/CreatMeeting'),
        },
        {
          name: "CreatMeetingForm",
          path: 'MeetingsManage/CreatMeetingForm',
          meta: {
            setIndex: "Works",
            subname: 'CreatMeeting',
            title: "创建会议",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingsManage/CreatMeeting/form'),
        },
        {
            name: "CreatMeetingZ",
                path: 'MeetingsManage/CreatMeetingZ',
            meta: {
            setIndex: "Works",
                subname: 'CreatMeeting',
                title: "创建会议",
                content: RoutesGroup.MeetingRecordName
            },
            component: () => import('@/views/Works/MeetingsManage/CreatMeeting/indexz'),
        },
        {
          name: "DoingMeetings",
          path: 'MeetingsManage/DoingMeetings',
          meta: {
            setIndex: "Works",
            subname: 'DoingMeetings',
            title: "进行中会议",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingsManage/DoingMeetings'),
        },
        {
          name: "DoingMeetingsActivity",
          path: 'MeetingsManage/DoingMeetings/Activity',
          meta: {
            setIndex: "Works",
            subname: 'DoingMeetings',
            title: "进行中会议",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingsManage/DoingMeetings/Activity'),
        },
        {
          name: "MeetingHistory",
          path: 'MeetingsManage/MeetingHistory',
          meta: {
            setIndex: "Works",
            subname: 'MeetingHistory',
            title: "会议记录",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingsManage/MeetingHistory'),
        },
        {
          name: "HistoryDetail",
          path: 'MeetingsManage/MeetingHistory/detail',
          meta: {
            setIndex: "Works",
            subname: 'MeetingHistory',
            title: "历史活动记录",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingsManage/MeetingHistory/detail'),
        },
        {
          name: "MeetingType",
          path: 'MeetingsManage/Type/index',
          meta: {
            setIndex: "Works",
            subname: 'MeetingType',
            title: "会议类型管理",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingsManage/Type/index'),
        },
        // 组织邀请
        {
          name: "InvitationLink",
          path: 'InvitationLink',
          meta: {
            setIndex: "Works",
            subname: 'InvitationLink',
            title: "组织邀请",
            content: RoutesGroup.InvitationName
          },
          component: () => import('@/views/Works/InvitationLink')
        },
        //述职评议开始
        {
          name: "WorkReport",
          path: 'WorkReport',
          meta: {
            setIndex: "Works",
            subname: 'WorkReport',
            title: "述职述廉",
            content: RoutesGroup.WorkReportName
          },
          component: () => import('@/views/Works/WorkReport'),
        },
        {
          name: "WorkReportForm",
          path: 'WorkReport/form',
          meta: {
            setIndex: "Works",
            subname: 'WorkReportForm',
            title: "我要述职",
            content: RoutesGroup.WorkReportName
          },
          component: () => import('@/views/Works/WorkReport/form'),
        },
        {
          name: "WorkReportDetail",
          path: 'WorkReport/detail',
          meta: {
            setIndex: "Works",
            subname: 'WorkReport',
            title: "述职述廉",
            content: RoutesGroup.WorkReportName
          },
          component: () => import('@/views/Works/WorkReport/detail'),
        },
        //述职评议结束

        // 党员示范岗开始
        {
          name: "Demonstration",
          path: 'Demonstration/complete',
          meta: {
            setIndex: "Works",
            subname: 'Demonstration',
            title: "已公示党员示范岗",
            content: RoutesGroup.DemonstrationName
          },
          component: () => import('@/views/Works/Demonstration/complete'),
        },
        {
          name: "DemonstrationEdit",
          path: 'Demonstration/complete/edit',
          meta: {
            setIndex: "Works",
            subname: 'Demonstration',
            title: "已公示党员示范岗编辑",
            content: RoutesGroup.DemonstrationName
          },
          component: () => import('@/views/Works/Demonstration/complete/edit'),
        },
        {
          name: "DemonstrationAdd",
          path: 'Demonstration/creat/add',
          meta: {
            setIndex: "Works",
            subname: 'DemonstrationAdd',
            title: "新增党员示范岗",
            content: RoutesGroup.DemonstrationName
          },
          component: () => import('@/views/Works/Demonstration/creat/add'),
        },
        {
          name: "DemonstrationDrafts",
          path: 'Demonstration/drafts',
          meta: {
            setIndex: "Works",
            subname: 'DemonstrationDrafts',
            title: "未公示党员示范岗",
            content: RoutesGroup.DemonstrationName
          },
          component: () => import('@/views/Works/Demonstration/drafts'),
        },
        {
          name: "DemonstrationDraftsEdit",
          path: 'Demonstration/drafts/edit',
          meta: {
            setIndex: "Works",
            subname: 'DemonstrationDrafts',
            title: "未公示党员示范岗编辑",
            content: RoutesGroup.DemonstrationName
          },
          component: () => import('@/views/Works/Demonstration/drafts/edit'),
        },
        // 党员示范岗结束

        // 党内关爱开始
        {
          name: "ComplaintsBox",
          path: 'Care/ComplaintsBox',
          meta: {
            setIndex: "Works",
            subname: 'ComplaintsBox',
            title: "党员之声",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/ComplaintsBox'),
        },
        {
          name: "CareHelp",
          path: 'Care/CareHelp',
          meta: {
            setIndex: "Works",
            subname: 'CareHelp',
            title: "生活困难党员名单",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/CareHelp'),
        },
        {
          name: "CareHelpAdd",
          path: 'Care/CareHelp/add',
          meta: {
            setIndex: "Works",
            subname: 'CareHelp',
            title: "新增党员名单",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/CareHelp/add'),
        },
        {
          name: "CareHelpEdit",
          path: 'Care/CareHelp/edit',
          meta: {
            setIndex: "Works",
            subname: 'CareHelp',
            title: "编辑贫困党员信息",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/CareHelp/edit'),
        },
        {
          name: "DiaryHistoryDetail",
          path: 'Care/DiaryHistory/detail',
          meta: {
            setIndex: "Works",
            subname: 'DiaryHistory',
            title: "历史日记",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/DiaryHistory/detail'),
        },
        {
          name: "DiaryHistory",
          path: 'Care/DiaryHistory',
          meta: {
            setIndex: "Works",
            subname: 'DiaryHistory',
            title: "历史日记",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/DiaryHistory'),
        },
        // 党内关爱结束

        // 统计开始
        {
          name: "BranchStatistics",
          path: 'DataStatistics/BranchStatistics',
          meta: {
            setIndex: "Works",
            subname: 'BranchStatistics',
            title: "组织概况统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/BranchStatistics'),
        },
        {
          name: "MainMeetingStatistics",
          path: 'DataStatistics/MainMeetingStatistics',
          meta: {
            setIndex: "Works",
            subname: 'MainMeetingStatistics',
            title: "三会一课统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/MainMeetingStatistics'),
        },
        {
          name: "MeetingStatistics",
          path: 'DataStatistics/MeetingStatistics',
          meta: {
            setIndex: "Works",
            subname: 'MeetingStatistics',
            title: "组织概况统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/MeetingStatistics'),
        },
        {
          name: "BranchStatistics",
          path: 'DataStatistics/BranchStatistics',
          meta: {
            setIndex: "Works",
            subname: 'BranchStatistics',
            title: "会议统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/BranchStatistics'),
        },
        {
          name: "EventRecordStatistics",
          path: 'DataStatistics/EventRecordStatistics',
          meta: {
            setIndex: "Works",
            subname: 'EventRecordStatistics',
            title: "党务公开统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/EventRecordStatistics'),
        },
        {
          name: "PersonalTaskStatistics",
          path: 'DataStatistics/PersonalTaskStatistics',
          meta: {
            setIndex: "Works",
            subname: 'PersonalTaskStatistics',
            title: "个人任务统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/PersonalTaskStatistics'),
        },
        {
          name: "OrganizationTaskStatistics",
          path: 'DataStatistics/OrganizationTaskStatistics',
          meta: {
            setIndex: "Works",
            subname: 'OrganizationTaskStatistics',
            title: "组织任务统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/OrganizationTaskStatistics'),
        },
        {
          name: "StudyAffairsStatistics",
          path: 'DataStatistics/StudyAffairsStatistics',
          meta: {
            setIndex: "Works",
            subname: 'StudyAffairsStatistics',
            title: "学习数据统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/StudyAffairsStatistics'),
        },
        {
          name: "PersonalPointsStatistics",
          path: 'DataStatistics/PersonalPointsStatistics',
          meta: {
            setIndex: "Works",
            subname: 'PersonalPointsStatistics',
            title: "个人积分统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/PersonalPointsStatistics'),
        },
        {
          name: "OrganizationPointsStatistics",
          path: 'DataStatistics/OrganizationPointsStatistics',
          meta: {
            setIndex: "Works",
            subname: 'OrganizationPointsStatistics',
            title: "组织积分统计",
            content: RoutesGroup.StatisticsName
          },
          component: () => import('@/views/Works/DataStatistics/OrganizationPointsStatistics'),
        },
        // 统计结束
        {
          name: "Profile",
          path: 'Profile',
          meta: {
            setIndex: "Works",
            subname: 'Abouts',
            title: "党组织简介",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/Abouts'),
        },
        {
          name: "Abouts",
          path: 'Profile/Abouts',
          meta: {
            setIndex: "Works",
            subname: 'Abouts',
            title: "党组织简介",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/Abouts'),
        },
        {
          name: "Schema",
          path: 'Profile/Schema',
          meta: {
            setIndex: "Works",
            subname: 'Schema',
            title: "组织架构",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/Schema'),
        },
        {
          name: "PartyZuzhiMembers",
          path: 'Profile/PartyZuzhiMembers',
          meta: {
            setIndex: "Works",
            subname: 'PartyZuzhiMembers',
            title: "组织部委员名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/PartyZuzhiMembers'),
        },
        {
          name: "CadreLists",
          path: 'Profile/CadreLists',
          meta: {
            setIndex: "Works",
            subname: 'CadreLists',
            title: "党组织委员名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/CadreLists'),
        }, {
          name: "DWPartyMembers",
          path: 'Profile/DWPartyMembers',
          meta: {
            setIndex: "Works",
            subname: 'DWPartyMembers',
            title: "党委委员名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/DWPartyMembers')
        },
        {
          name: "PartyMien",
          path: 'Profile/PartyMien',
          meta: {
            setIndex: "Works",
            subname: 'PartyMien',
            title: "党员风采",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/PartyMien'),
        },
        {
          name: "MonicaLists",
          path: 'Profile/MonicaLists',
          meta: {
            setIndex: "Works",
            subname: 'MonicaLists',
            title: "公司成员名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/MonicaLists'),
        },
        {
          name: "PartyMembers",
          path: 'Profile/PartyMembers',
          meta: {
            setIndex: "Works",
            subname: 'PartyMembers',
            title: "党员名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/PartyMembers'),
        },
        {
          name: "PrepareMembers",
          path: 'Profile/PrepareMembers',
          meta: {
            setIndex: "Works",
            subname: 'PrepareMembers',
            title: "预备党员名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/Preparemembers'),
        },
      {
          name: "PartyMemberapply",
              path: 'Profile/PartyMemberapply',
          meta: {
              setIndex: "Works",
                  subname: 'PartyMemberapply',
                  title: "拟发展对象名册",
                  content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/PartyMemberapply'),
      },
        {
          name: "ActivistMembers",
          path: 'Profile/ProfileActivistMembers',
          meta: {
            setIndex: "Works",
            subname: 'ActivistMembers',
            title: "入党积极分子名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/ActivistMembers'),
        },
        {
          name: "PartyMembership",
          path: 'Profile/PartyMembership',
          meta: {
            setIndex: "Works",
            subname: 'PartyMembership',
            title: "入党申请阶段",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/PartyMembership'),
        },
        {
          name: "PartyCirculation",
          path: 'Profile/PartyCirculation',
          meta: {
            setIndex: "Works",
            subname: 'PartyCirculation',
            title: "流入党员名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/PartyCirculation'),
        },

        {
          name: "PartyCirCulationsOut",
          path: 'Profile/PartyCirCulationsOut',
          meta: {
            setIndex: "Works",
            subname: 'PartyCirCulationsOut',
            title: "流出党员名册",
            content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/PartyCirCulationsOut'),
        },
      {
          name: "PartyMemberNoapply",
              path: 'Profile/PartyMemberNoapply',
          meta: {
              setIndex: "Works",
                  subname: 'PartyMemberNoapply',
                  title: "非党员名册",
                  content: RoutesGroup.ProfileName
          },
          component: () => import('@/views/Works/Profile/PartyMemberNoapply'),
      },
      {
        name: "PartyMemberOut",
            path: 'Profile/PartyMemberOut',
        meta: {
            setIndex: "Works",
                subname: 'PartyMemberOut',
                title: "流动名册",
                content: RoutesGroup.ProfileName
        },
        component: () => import('@/views/Works/Profile/PartyMemberOut'),
    },
        // {
        //   name: "HistoryEvents",
        //   path: 'Organize/HistoryEvents',
        //   meta: {
        //     setIndex: "Works",
        //     subname: 'HistoryEvents',
        //     title: "历史活动记录",
        //     content: RoutesGroup.OrganizeName
        //   },
        //   component: () => import('@/views/Works/Organize/HistoryEvents'),
        // },
        {
          // 已公示简报列表
          name: "EventRecordComplete",
          path: 'EventRecord/complete',
          meta: {
            setIndex: "Works",
            subname: 'EventRecordComplete',
            title: "已公示党务",
            content: RoutesGroup.EventRecordName
          },
          component: () => import('@/views/Works/EventRecord/complete/list.vue'),
        },
        //已公示简报编辑页面
        {
          name: "EventRecordCompleteEdit",
          path: 'EventRecord/complete/edit',
          meta: {
            setIndex: "Works",
            subname: 'EventRecordComplete',
            title: "已公示党务",
            content: RoutesGroup.EventRecordName
          },
          component: () => import('@/views/Works/EventRecord/complete/edit.vue'),
        },
        //新建简报
        {
          name: "EventRecordCreat",
          path: 'EventRecord/creat',
          meta: {
            setIndex: "Works",
            subname: 'EventRecordCreat',
            title: "新建内容",
            content: RoutesGroup.EventRecordName
          },
          component: () => import('@/views/Works/EventRecord/creat'),
        },
        //未公示简报列表页
        {
          name: "EventRecordDrafts",
          path: 'EventRecord/drafts',
          meta: {
            setIndex: "Works",
            subname: 'EventRecordDrafts',
            title: "未公示党务",
            content: RoutesGroup.EventRecordName
          },
          component: () => import('@/views/Works/EventRecord/drafts/list.vue'),
        },
        //未公示简报编辑页
        {
          name: "EventRecordDraftsEdit",
          path: 'EventRecord/drafts/edit',
          meta: {
            setIndex: "Works",
            subname: 'EventRecordDrafts',
            title: "未公示党务",
            content: RoutesGroup.EventRecordName
          },
          component: () => import('@/views/Works/EventRecord/drafts/edit.vue'),
        },
        // 文件管理开始
        {
          name: "FileManageMent",
          path: 'Files/FileManageMent',
          meta: {
            setIndex: "Works",
            subname: 'FileManageMent',
            title: "文件管理",
            content: RoutesGroup.LearningName
          },
          component: () => import('@/views/Works/Files/FileManageMent'),
        },
        {
          name: "FileManageMentDetail",
          path: 'Files/FileManageMent/detail',
          meta: {
            setIndex: "Works",
            subname: 'FileManageMent',
            title: "文件管理上传",
            content: RoutesGroup.LearningName
          },
          component: () => import('@/views/Works/Files/FileManageMent/detail'),
        },
        {
          name: "SuperiorFile",
          path: 'Files/SuperiorFile',
          meta: {
            setIndex: "Works",
            subname: 'SuperiorFile',
            title: "上级文件",
            content: RoutesGroup.LearningName
          },
          component: () => import('@/views/Works/Files/SuperiorFile'),
        },
        {
          name: "SendFile",
          path: 'Files/SendFile',
          meta: {
            setIndex: "Works",
            subname: 'SendFile',
            title: "上级文件",
            content: RoutesGroup.LearningName
          },
          component: () => import('@/views/Works/Files/SendFile'),
        },
        {
          name: "SendFileRecord",
          path: 'Files/SendFileRecord',
          meta: {
            setIndex: "Works",
            subname: 'SendFileRecord',
            title: "上级文件",
            content: RoutesGroup.LearningName
          },
          component: () => import('@/views/Works/Files/SendFileRecord'),
        },
        {
          name: "AddLearningPlan",
          path: 'Files/AddLearningPlan',
          meta: {
            setIndex: "Works",
            subname: 'AddLearningPlan',
            title: "添加学习计划",
            content: RoutesGroup.LearningName
          },
          component: () => import('@/views/Works/Files/AddLearningPlan'),
        },
        {
          name: "LearningPlanList",
          path: 'Files/LearningPlanList',
          meta: {
            setIndex: "Works",
            subname: 'LearningPlanList',
            title: "添加学习计划",
            content: RoutesGroup.LearningName
          },
          component: () => import('@/views/Works/Files/LearningPlanList'),
        },
        {
          name: "LearningPlanDetail",
          path: 'Files/LearningPlanList/detail',
          meta: {
            setIndex: "Works",
            subname: 'LearningPlanList',
            title: "添加学习计划",
            content: RoutesGroup.LearningName
          },
          component: () => import('@/views/Works/Files/LearningPlanList/detail'),
        },
        // 文件管理结束
        {
          name: "DiaryCreat",
          path: 'Care/DiaryCreat',
          meta: {
            setIndex: "Works",
            subname: 'DiaryHistory',
            title: "新建日记",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/DiaryCreat'),
        },
        {
          name: "RegistrationSheet",
          path: 'Care/RegistrationSheet',
          meta: {
            setIndex: "Works",
            subname: 'RegistrationSheet',
            title: "关爱帮扶登记表",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/RegistrationSheet'),
        },
        {
          name: "SpecialNeeds",
          path: 'Care/SpecialNeeds',
          meta: {
            setIndex: "Works",
            subname: 'SpecialNeeds',
            title: "党员特殊需求",
            content: RoutesGroup.CareName
          },
          component: () => import('@/views/Works/Care/SpecialNeeds'),
        },
        {
          name: "MeetingRecord",
          path: 'MeetingRecord',
          meta: {
            setIndex: "Works",
            subname: 'MeetingRecord',
            title: "添加会议",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingRecord'),
        },
        {
          name: "MeetingRecordHistory",
          path: 'MeetingRecord/history',
          meta: {
            setIndex: "Works",
            subname: 'MeetingRecordHistory',
            title: "会议记录",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingRecord/history'),
        },
        {
          name: "MeetingRecordDetail",
          path: 'MeetingRecord/detail',
          meta: {
            setIndex: "Works",
            subname: 'MeetingRecordHistory',
            title: "会议记录",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingRecord/detail'),
        },
        {
          name: "MeetingRecordEdit",
          path: 'MeetingRecord/edit',
          meta: {
            setIndex: "Works",
            subname: 'MeetingRecordHistory',
            title: "会议记录",
            content: RoutesGroup.MeetingRecordName
          },
          component: () => import('@/views/Works/MeetingRecord/edit'),
        },
        {
          name: "CoursewarEventSigne",
          path: 'CoursewarEventSigne',
          meta: {
            setIndex: "Works",
            subname: 'Compulsory',
            title: "必修课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/Compulsory'),
        },
        {
          name: "Compulsory",
          path: 'CoursewarEventSigne/Compulsory',
          meta: {
            setIndex: "Works",
            subname: 'Compulsory',
            title: "必修课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/Compulsory'),
        },
        {
          name: "CompulsoryDetail",
          path: 'CoursewarEventSigne/Compulsory/detail',
          meta: {
            setIndex: "Works",
            subname: 'Compulsory',
            title: "必修课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/Compulsory/detail'),
        },
        {
          name: "CompulsoryList",
          path: 'CoursewarEventSigne/Compulsory/list',
          meta: {
            setIndex: "Works",
            subname: 'Compulsory',
            title: "必修课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/Compulsory/list'),
        },
        {
          name: "ElectiveCourse",
          path: 'CoursewarEventSigne/ElectiveCourse',
          meta: {
            setIndex: "Works",
            subname: 'ElectiveCourse',
            title: "选修课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/ElectiveCourse'),
        },
        {
          name: "ElectiveCourseDetail",
          path: 'CoursewarEventSigne/ElectiveCourse/detail',
          meta: {
            setIndex: "Works",
            subname: 'ElectiveCourse',
            title: "选修课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/ElectiveCourse/detail'),
        },
        {
          name: "ElectiveCourseList",
          path: 'CoursewarEventSigne/ElectiveCourse/list',
          meta: {
            setIndex: "Works",
            subname: 'ElectiveCourse',
            title: "选修课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/ElectiveCourse/list'),
        },
        {
          name: "Optional",
          path: 'CoursewarEventSigne/Optional',
          meta: {
            setIndex: "Works",
            subname: 'Optional',
            title: "自选课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/Optional'),
        },
        {
          name: "OptionalDetail",
          path: 'CoursewarEventSigne/Optional/detail',
          meta: {
            setIndex: "Works",
            subname: 'Optional',
            title: "自选课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/Optional/detail'),
        },
        {
          name: "OptionalList",
          path: 'CoursewarEventSigne/Optional/list',
          meta: {
            setIndex: "Works",
            subname: 'Optional',
            title: "自选课件资源",
            content: RoutesGroup.CoursewarEventSigneName
          },
          component: () => import('@/views/Works/CoursewarEventSigne/Optional/list'),
        },
        {
          name: "DataQuerySuperior",
          path: 'DataQuery/DataQuerySuperior',
          meta: {
            setIndex: "Works",
            subname: 'DataQuerySuperior',
            title: "上级文件",
            content: RoutesGroup.DataQueryName
          },
          component: () => import('@/views/Works/DataQuery/DataQuerySuperior'),
        },
        {
          name: "DataQuerySystem",
          path: 'DataQuery/DataQuerySystem',
          meta: {
            setIndex: "Works",
            subname: 'DataQuerySystem',
            title: "党务法规制度",
            content: RoutesGroup.DataQueryName
          },
          component: () => import('@/views/Works/DataQuery/DataQuerySystem'),
        },

        {
          name: "DataQueryWorks",
          path: 'DataQuery/DataQueryWorks',
          meta: {
            setIndex: "Works",
            subname: 'DataQueryWorks',
            title: "支部工作务实",
            content: RoutesGroup.DataQueryName
          },
          component: () => import('@/views/Works/DataQuery/DataQueryWorks'),
        },
        {
          name: "DataQuerySuperiorDetail",
          path: 'DataQuery/DataQuerySuperior/detail',
          meta: {
            setIndex: "Works",
            subname: 'DataQuerySuperior',
            title: "上级文件",
            content: RoutesGroup.DataQueryName
          },
          component: () => import('@/views/Works/DataQuery/DataQuerySuperior/detail'),
        },
        {
          name: "DataQuerySystemDetail",
          path: 'DataQuery/DataQuerySystem/detail',
          meta: {
            setIndex: "Works",
            subname: 'DataQuerySystem',
            title: "党务法规制度",
            content: RoutesGroup.DataQueryName
          },
          component: () => import('@/views/Works/DataQuery/DataQuerySystem/detail'),
        },
        {
          name: "DataQueryWorksDetail",
          path: 'DataQuery/DataQueryWorks/detail',
          meta: {
            setIndex: "Works",
            subname: 'DataQueryWorks',
            title: "支部工作务实",
            content: RoutesGroup.DataQueryName
          },
          component: () => import('@/views/Works/DataQuery/DataQueryWorks/detail'),
        },
        {
          name: 'CollectMoney',
          path: 'CollectMoney',
          meta: {
            setIndex: "Works",
            subname: 'CollectMoney',
            title: "党费管理",
            content: RoutesGroup.CollectMoneyName
          },
          component: () => import('@/views/Works/CollectMoney'),
        },
        {
          name: 'DWCollectMoney',
          path: 'DWCollectMoney',
          meta: {
            setIndex: "Works",
            subname: 'DWCollectMoney',
            title: "党费管理",
            content: RoutesGroup.CollectMoneyName
          },
          component: () => import('@/views/Works/DWCollectMoney'),
        },
        {
          name: 'CollectMoneyPerformRecord',
          path: 'CollectMoneyPerformRecord',
          meta: {
            setIndex: "Works",
            subname: 'CollectMoneyPerformRecord',
            title: "党费下拨记录",
            content: RoutesGroup.CollectMoneyName
          },
          component: () => import('@/views/Works/CollectMoneyPerformRecord'),
        },
        {
          name: 'CollectMoneyTurnRecord',
          path: 'CollectMoneyTurnRecord',
          meta: {
            setIndex: "Works",
            subname: 'CollectMoneyTurnRecord',
            title: "党费上缴记录",
            content: RoutesGroup.CollectMoneyName
          },
          component: () => import('@/views/Works/CollectMoneyTurnRecord'),
        },
        {
          name: 'CollectMoneyUseRecord',
          path: 'CollectMoneyUseRecord',
          meta: {
            setIndex: "Works",
            subname: 'CollectMoneyUseRecord',
            title: "党费自用记录",
            content: RoutesGroup.CollectMoneyName
          },
          component: () => import('@/views/Works/CollectMoneyUseRecord'),
        },
        {
          name: 'Case',
          path: 'Case',
          meta: {
            subname: 'ChinaCase',
            setIndex: "Works",
            title: '全国优秀工作案例',
            content: RoutesGroup.CaseName
          },
          component: () => import('@/views/Works/Case/ChinaCase')
        },
        {
          name: 'ChinaCase',
          path: 'Case/ChinaCase',
          meta: {
            subname: 'ChinaCase',
            setIndex: "Works",
            title: '全国优秀工作案例',
            content: RoutesGroup.CaseName
          },
          component: () => import('@/views/Works/Case/ChinaCase')
        },
        {
          name: 'HCCase',
          path: 'Case/HCCase',
          meta: {
            subname: 'HCCase',
            setIndex: "Works",
            title: '线下党建阵地案例',
            content: RoutesGroup.CaseName
          },
          component: () => import('@/views/Works/Case/HCCase')
        },
        {
          name: 'LocalCase',
          path: 'Case/LocalCase',
          meta: {
            subname: 'LocalCase',
            setIndex: "Works",
            title: '线下党建阵地案例',
            content: RoutesGroup.CaseName
          },
          component: () => import('@/views/Works/Case/LocalCase')
        },
        {
          name: 'ChinaCaseDetail',
          path: 'Case/ChinaCase/detail',
          meta: {
            subname: 'ChinaCase',
            setIndex: "Works",
            title: '全国优秀工作案例',
            content: RoutesGroup.CaseName
          },
          component: () => import('@/views/Works/Case/ChinaCase/detail')
        },
        {
          name: 'HCCaseDetail',
          path: 'Case/HCCase/detail',
          meta: {
            subname: 'HCCase',
            setIndex: "Works",
            title: '线下党建阵地案例',
            content: RoutesGroup.CaseName
          },
          component: () => import('@/views/Works/Case/HCCase/detail')
        },
        {
          name: 'LocalCaseDetail',
          path: 'Case/LocalCase/detal',
          meta: {
            subname: 'LocalCase',
            setIndex: "Works",
            title: '线下党建阵地案例',
            content: RoutesGroup.CaseName
          },
          component: () => import('@/views/Works/Case/LocalCase/detail')
        },
        {
          name: 'Theme',
          path: 'Theme',
          meta: {
            setIndex: "Works",
            subname: 'Theme',
            title: '主题教育',
            content: RoutesGroup.ThemeName,
          },
          component: () => import('@/views/Works/Theme')
        },
        {
          name: 'ThemeDetail',
          path: 'Theme/detail',
          content: RoutesGroup.ThemeName,
          meta: {
            setIndex: "Works",
            subname: 'Theme',
            title: '主题教育',
            content: RoutesGroup.ThemeName,
          },
          component: () => import('@/views/Works/Theme/detail')
        },
        {
          name: 'Growing',
          path: 'PartyerGrow/Growing',
          meta: {
            setIndex: "Works",
            subname: 'Growing',
            title: '发展党员',
            content: RoutesGroup.PartyerGrowName,
          },
          component: () => import('@/views/Works/PartyerGrow/Growing')
        },
        {
          name: 'GrowingReview',
          path: 'PartyerGrow/GrowingReview',
          meta: {
            setIndex: "Works",
            subname: 'Growing',
            title: '发展党员',
            content: RoutesGroup.PartyerGrowName,
          },
          component: () => import('@/views/Works/PartyerGrow/Growing/review')
        },
        {
          name: 'formal',
          path: 'PartyerGrow/formal',
          meta: {
            setIndex: "Works",
            subname: 'formal',
            title: '发展党员',
            content: RoutesGroup.PartyerGrowName,
          },
          component: () => import('@/views/Works/PartyerGrow/formal')
        },
        {
          name: 'FormalReview',
          path: 'PartyerGrow/FormalReview',
          meta: {
            setIndex: "Works",
            subname: 'formal',
            title: '发展党员',
            content: RoutesGroup.PartyerGrowName,
          },
          component: () => import('@/views/Works/PartyerGrow/formal/review')
        },
        {
          name: 'Waiting',
          path: 'PartyerGrow/Waiting',
          meta: {
            setIndex: "Works",
            subname: 'Waiting',
            title: '发展党员',
            content: RoutesGroup.PartyerGrowName,
          },
          component: () => import('@/views/Works/PartyerGrow/Waiting')
        },
        {
          name: 'WaitingReview',
          path: 'PartyerGrow/WaitingReview',
          meta: {
            setIndex: "Works",
            subname: 'Waiting',
            title: '发展党员',
            content: RoutesGroup.PartyerGrowName,
          },
          component: () => import('@/views/Works/PartyerGrow/Waiting/review')
        },
        // 督查
        {
          name: 'TaskLeader',
          path: 'Task/Leader',
          meta: {
            setIndex: "Works",
            subname: 'TaskLeader',
            title: '党委督查任务',
            content: RoutesGroup.TaskName,
          },
          component: () => import('@/views/Works/Task/Leader')
        },
        {
          name: 'TaskLeaderDetail',
          path: 'Task/Leader/detail',
          meta: {
            setIndex: "Works",
            subname: 'TaskLeader',
            title: '党委督查任务',
            content: RoutesGroup.TaskName,
          },
          component: () => import('@/views/Works/Task/Leader/detail')
        },
        {
          name: 'TaskLeaderForm',
          path: 'Task/Leader/form',
          meta: {
            setIndex: "Works",
            subname: 'TaskLeaderForm',
            title: '新建督查任务',
            content: RoutesGroup.TaskName,
          },
          component: () => import('@/views/Works/Task/Leader/form')
        },
        {
          name: 'TaskBranch',
          path: 'Task/Branch',
          meta: {
            setIndex: "Works",
            subname: 'TaskBranch',
            title: '支部督查任务',
            content: RoutesGroup.BranchMyTaskName,
          },
          component: () => import('@/views/Works/Task/Branch')
        },
        {
          name: 'TaskBranchDetail',
          path: 'Task/Branch/detail',
          meta: {
            setIndex: "Works",
            subname: 'TaskBranch',
            title: '支部督查任务',
            content: RoutesGroup.BranchMyTaskName,
          },
          component: () => import('@/views/Works/Task/Branch/detail')
        },
        {
          name: 'TaskBranchComplate',
          path: 'Task/Branch/ComplateList',
          meta: {
            setIndex: "Works",
            subname: 'TaskBranch',
            title: '支部督查任务',
            content: RoutesGroup.BranchMyTaskName,
          },
          component: () => import('@/views/Works/Task/Branch/ComplateList')
        },
        {
          name: 'TaskBranchComplateDetail',
          path: 'Task/Branch/detail',
          meta: {
            setIndex: "Works",
            subname: 'TaskBranch',
            title: '支部督查任务',
            content: RoutesGroup.BranchMyTaskName,
          },
          component: () => import('@/views/Works/Task/Branch/detail')
        },
        // 支部下发党员任务
        {
          name: 'TaskRelease',
          path: 'TaskRelease',
          meta: {
            setIndex: "Works",
            subname: 'TaskRelease',
            title: '督查任务',
            content: RoutesGroup.BranchTaskName,
          },
          component: () => import('@/views/Works/TaskRelease')
        },
        // 支部下发党员任务详情
        {
          name: 'TaskReleaseDetail',
          path: 'TaskRelease/detail',
          meta: {
            setIndex: "Works",
            subname: 'TaskLeader',
            title: '督查任务',
            content: RoutesGroup.BranchTaskName,
          },
          component: () => import('@/views/Works/TaskRelease/detail')
        },
        {
          name: 'TaskReleaseDetailSub',
          path: 'TaskRelease/detailsub',
          meta: {
            setIndex: "Works",
            subname: 'TaskReleaseList',
            title: '督查任务',
            content: RoutesGroup.BranchTaskName,
          },
          component: () => import('@/views/Works/TaskRelease/detailsub')
        },
        // 支部下发党员任务列表
        {
          name: 'TaskReleaseList',
          path: 'TaskRelease/List',
          meta: {
            setIndex: "Works",
            subname: 'TaskReleaseList',
            title: '党员督查任务',
            content: RoutesGroup.BranchTaskName,
          },
          component: () => import('@/views/Works/TaskRelease/list')
        },
        // 支部下发党员项目列表
        {
          name: 'TaskReleaseProjectList',
          path: 'TaskRelease/ProjectList',
          meta: {
            setIndex: "Works",
            subname: 'TaskReleaseProjectList',
            title: '党员督查任务',
            content: RoutesGroup.BranchTaskName,
          },
          component: () => import('@/views/Works/TaskRelease/TaskReleaseProjectList')
        },
        // 党员、职工素质培训
        {
          name: 'TrainingList',
          path: 'QualityTraining/TrainingList',
          meta: {
            setIndex: "Works",
            subname: 'TrainingList',
            title: '培训管理',
            content: RoutesGroup.QualityTrainingName,
          },
          component: () => import('@/views/Works/QualityTraining/TrainingList')
        },
        {
          name: 'TrainingDetail',
          path: 'QualityTraining/TrainingDetail',
          meta: {
            setIndex: "Works",
            subname: 'TrainingDetail',
            title: '培训列表',
            content: RoutesGroup.QualityTrainingName,
          },
          component: () => import('@/views/Works/QualityTraining/TrainingDetail')
        },
        //题库管理
        {
          name: 'QuestionBank',
          path: 'QualityTraining/QuestionBank',
          meta: {
            setIndex: "Works",
            subname: 'QuestionBank',
            title: '题库管理',
            content: RoutesGroup.QualityTrainingName,
          },
          component: () => import('@/views/Works/QualityTraining/QuestionBank')
        },
        //考试管理
        {
          name: 'ExamManagement',
          path: 'QualityTraining/ExamManagement',
          meta: {
            setIndex: "Works",
            subname: 'ExamManagement',
            title: '考试管理',
            content: RoutesGroup.QualityTrainingName,
          },
          component: () => import('@/views/Works/QualityTraining/ExamManagement')
        },
        //成绩分析
        {
          name: 'GradeAnalysis',
          path: 'QualityTraining/GradeAnalysis',
          meta: {
            setIndex: "Works",
            subname: 'GradeAnalysis',
            title: '成绩分析',
            content: RoutesGroup.QualityTrainingName,
          },
          component: () => import('@/views/Works/QualityTraining/GradeAnalysis')
        },
        //凝心聚力工作平台
        {
          name: 'LaborUnion',
          path: 'CheerShare/LaborUnion',
          meta: {
            setIndex: "Works",
            subname: 'LaborUnion',
            title: '工会',
            content: RoutesGroup.CheerShareName,
          },
          component: () => import('@/views/Works/CheerShare/LaborUnion')
        },
        {
          name: "TeamMoney",
          path: 'CheerShare/TeamMoney',
          meta: {
            setIndex: "Works",
            subname: 'WomensWork|LaborUnion|Komsomol',
            title: "会费",
            content: RoutesGroup.CheerShareName
          },
          component: () => import('@/views/Works/CheerShare/TeamMoney'),
        },
        {
          name: "TeamSchema",
          path: 'CheerShare/TeamSchema',
          meta: {
            setIndex: "Works",
            subname: 'WomensWork|LaborUnion|Komsomol',
            title: "团队架构",
            content: RoutesGroup.CheerShareName
          },
          component: () => import('@/views/Works/CheerShare/TeamSchema'),
        },
        {
          name: "MemberList",
          path: 'CheerShare/MemberList',
          meta: {
            setIndex: "Works",
            subname: 'WomensWork|LaborUnion|Komsomol',
            title: "团队成员",
            content: RoutesGroup.CheerShareName
          },
          component: () => import('@/views/Works/CheerShare/MemberList'),
        },
        {
          name: "MemberList",
          path: 'CheerShare/MemberList',
          meta: {
            setIndex: "Works",
            subname: 'WomensWork|LaborUnion|Komsomol',
            title: "团队成员",
            content: RoutesGroup.CheerShareName
          },
          component: () => import('@/views/Works/CheerShare/MemberList'),
        },
        {
          name: "ResourceList",
          path: 'CheerShare/ResourceList/:group_type',
          meta: {
            setIndex: "Works",
            subname: 'ResourceList',
            title: "资源列表",
            content: RoutesGroup.CheerShareName
          },
          component: () => import('@/views/Works/CheerShare/ResourceList'),
        },
        {
          name: 'Komsomol',
          path: 'CheerShare/Komsomol',
          meta: {
            setIndex: "Works",
            subname: 'Komsomol',
            title: '共青团',
            content: RoutesGroup.CheerShareName,
          },
          component: () => import('@/views/Works/CheerShare/Komsomol')
        },
        {
          name: 'WomensWork',
          path: 'CheerShare/WomensWork',
          meta: {
            setIndex: "Works",
            subname: 'WomensWork',
            title: '妇联',
            content: RoutesGroup.CheerShareName,
          },
          component: () => import('@/views/Works/CheerShare/WomensWork')
        },
        //三重一大决策管理
        {
          name: 'DecisionManagementCreat',
          path: 'DecisionManagement/Creat',
          meta: {
            setIndex: "Works",
            subname: 'DecisionManagementCreat',
            title: '创建决策',
            content: RoutesGroup.DecisionManagementName,
          },
          component: () => import('@/views/Works/DecisionManagement/Creat')
        },
        {
          name: 'DecisionManagementRecord',
          path: 'DecisionManagement/Record',
          meta: {
            setIndex: "Works",
            subname: 'DecisionManagementRecord',
            title: '决策记录',
            content: RoutesGroup.DecisionManagementName,
          },
          component: () => import('@/views/Works/DecisionManagement/Record')
        },
      ]
    }]
  },
  {
    path: '/',
    component: layout,
    children: [{
      name: 'Branch',
      path: '/Branch',
      component: Branch,
      meta: {
        title: '党组织管理',
        setIndex: "Branch",
        moudles: true
      },
      children: [{
        name: "CollectMoneyStatistics",
        path: 'CollectMoneyStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'CollectMoneyStatistics',
          title: "党费收缴统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/CollectMoneyStatistics')
      }, {
        name: "MemberStatistics",
        path: 'MemberStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'MemberStatistics',
          title: "成员统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/MemberStatistics')
      }, {
        name: "ConferenceStatistics",
        path: 'ConferenceStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'ConferenceStatistics',
          title: "会议统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/ConferenceStatistics')
      }, {
        name: "AboutsStatistics",
        path: 'AboutsStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'AboutsStatistics',
          title: "党组织简介",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/Abouts')
      }, {
        name: "BranchHonor",
        path: 'BranchHonor/',
        meta: {
          setIndex: "Branch",
          subname: 'BranchHonor',
          title: "支部荣誉",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/BranchHonor')
      }, {
        name: "SchemaStatistics",
        path: 'SchemaStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SchemaStatistics',
          title: "组织架构",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/Schema')
      }, {
        name: "CadreListsStatistics",
        path: 'CadreListsStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'CadreListsStatistics',
          title: "党组织委员登记表",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/CadreLists')
      }, {
        name: "PartyMienStatistics",
        path: 'PartyMienStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'PartyMienStatistics',
          title: "党支部委员分工",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/PartyMien')
      }, {
        name: "PartyMembersStatistics",
        path: 'PartyMembersStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'PartyMembersStatistics',
          title: "党员名册",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/PartyMembers')
      }, {
        name: "PrepareMembersStatistics",
        path: 'PrepareMembersStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'PrepareMembersStatistics',
          title: "预备党员名册",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/PrepareMembers')
      }, {
        name: "ActivistMembersStatistics",
        path: 'ActivistMembersStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'ActivistMembersStatistics',
          title: "入党积极分子名册",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/ActivistMembers')
      },
      {
        name: "Outmember",
        path: 'Outmember/',
        meta: {
          setIndex: "Branch",
          subname: 'Outmember',
          title: "流动成员名册",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/PartyMemberOut')
      },
      // 会议记录
      {
        name: "MeetingHistorys",
        path: 'MeetingHistorys/',
        meta: {
          setIndex: "Branch",
          subname: 'MeetingHistorys',
          title: "会议记录",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/MeetingHistorys')
      },
      // 会议记录详情
      {
        name: "MeetingHistoryDetail",
        path: 'MeetingHistoryDetail/',
        meta: {
          setIndex: "Branch",
          subname: 'MeetingHistorys',
          title: "会议记录",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/MeetingHistorys/detail')
      },
      // 已公示未公示活动简报
      {
        name: "briefings",
        path: 'briefings/',
        meta: {
          setIndex: "Branch",
          subname: 'briefings',
          title: "党务公开",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/briefings')
      },
      // 已公示活动简报详情
      {
        name: "briefingsDetail",
        path: 'briefingsDetail/',
        meta: {
          setIndex: "Branch",
          subname: 'briefings',
          title: "党务公开",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/briefings/detail')
      },
      // 组织概况统计
      {
        name: "SubBranchStatistics",
        path: 'SubBranchStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubBranchStatistics',
          title: "组织概况统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/BranchStatistics')
      },
      // 三会一课统计
      {
        name: "SubMainMeetingStatistics",
        path: 'SubMainMeetingStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubMainMeetingStatistics',
          title: "三会一课统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/MainMeetingStatistics')
      },
      // 党组织会议统计
      {
        name: "SubMeetingStatistics",
        path: 'SubMeetingStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubMeetingStatistics',
          title: "党组织会议统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/MeetingStatistics')
      },
      // 党务公开统计
      {
        name: "SubEventRecordStatistics",
        path: 'SubEventRecordStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubEventRecordStatistics',
          title: "党务公开统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/EventRecordStatistics')
      },
      // 个人任务统计
      {
        name: "SubPersonalTaskStatistics",
        path: 'SubPersonalTaskStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubPersonalTaskStatistics',
          title: "个人任务统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/PersonalTaskStatistics')
      },
      // 组织任务统计
      {
        name: "SubOrganizationTaskStatistics",
        path: 'SubOrganizationTaskStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubOrganizationTaskStatistics',
          title: "组织任务统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/OrganizationTaskStatistics')
      },
      // 学习数据统计
      {
        name: "SubStudyAffairsStatistics",
        path: 'SubStudyAffairsStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubStudyAffairsStatistics',
          title: "学习数据统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/StudyAffairsStatistics')
      },
      // 个人积分统计
      {
        name: "SubPersonalPointsStatistics",
        path: 'SubPersonalPointsStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubPersonalPointsStatistics',
          title: "个人积分统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/PersonalPointsStatistics')
      },
      // 组织积分统计
      {
        name: "SubOrganizationPointsStatistics",
        path: 'SubOrganizationPointsStatistics/',
        meta: {
          setIndex: "Branch",
          subname: 'SubOrganizationPointsStatistics',
          title: "组织积分统计",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/DataStatistics/OrganizationPointsStatistics')
      },
      // 党费收缴记录
      {
        name: "CollectMoneys",
        path: 'CollectMoneys/',
        meta: {
          setIndex: "Branch",
          subname: 'CollectMoneys',
          title: "党费收缴记录",
          content: RoutesGroup.BranchName
        },
        component: () => import('@/views/Branch/CollectMoneys')
      },
     
      ]
    }]
  },
  {
    path: '/',
    component: layout,
    children: [{
      name: 'Management',
      path: '/Management',
      component: Management,
      meta: {
        title: '系统中心',
        setIndex: "Management",
        moudles: true
      },
      children: [{
        name: "NowManager",
        path: 'NowManager',
        meta: {
          setIndex: "Management",
          subname: 'NowManager',
          title: "现任管理员",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/NowManager')
      }, {
        name: "PastManager",
        path: 'PastManager',
        meta: {
          setIndex: "Management",
          subname: 'PastManager',
          title: "历届管理员",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/PastManager')
      }, {
        name: "DataManagement",
        path: 'DataManagement',
        meta: {
          setIndex: "Management",
          subname: 'DataManagement',
          title: "基本信息设置",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/DataManagement')
      }, {
        name: "Notice",
        path: 'Notice',
        meta: {
          setIndex: "Management",
          subname: 'Notice',
          title: "消息通知",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/Notice')
      }, {
        name: "Statistics",
        path: 'Statistics',
        meta: {
          setIndex: "Management",
          subname: 'Statistics',
          title: "支部分布图示",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/Statistics')
      },
      {
        name: "System",
        path: 'System',
        meta: {
          setIndex: "Management",
          subname: 'System',
          title: "系统设置",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/System')
      },
      // 支部管理列表
      {
        name: "BranchManagement",
        path: 'BranchManagement',
        meta: {
          setIndex: "Management",
          subname: 'BranchManagement',
          title: "支部管理",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/BranchManagement')
      },
      {
        name: "password",
        path: 'password',
        meta: {
          setIndex: "Management",
          subname: 'password',
          title: "修改密码",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/password')
      },

      // 创建支部
      {
        name: "BranchManagementAdd",
        path: 'BranchManagementAdd',
        meta: {
          setIndex: "Management",
          subname: 'BranchManagement',
          title: "支部管理",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/BranchManagement/add')
      },
      // 支部表单
      {
        name: "BranchManagementFrom",
        path: 'BranchManagementFrom',
        meta: {
          setIndex: "Management",
          subname: 'BranchManagement',
          title: "支部管理",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/BranchManagement/from')
      },
      // 修改支部名称
      {
        name: "BranchManagementModify",
        path: 'BranchManagementModify',
        meta: {
          setIndex: "Management",
          subname: 'BranchManagement',
          title: "支部管理",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/BranchManagement/Modify')
      },
      // 创建账号表单
      {
        name: "BranchManagementNameFrom",
        path: 'BranchManagementNameFrom',
        meta: {
          setIndex: "Management",
          subname: 'BranchManagement',
          title: "支部管理",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/BranchManagement/nameFrom')
      },
      // 修改账号表单
      {
        name: "BranchManagementNameFroms",
        path: 'BranchManagementNameFroms',
        meta: {
          setIndex: "Management",
          subname: 'BranchManagement',
          title: "支部管理",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/BranchManagement/nameFroms')
      },
      {
        name: "SysLogout",
        path: 'SysLogout',
        meta: {
          setIndex: "Management",
          subname: 'SysLogout',
          title: "退出当前账户",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/SysLogout')
      },
      {
        name: "geographical",
        path: 'geographical',
        meta: {
          setIndex: "Management",
          subname: 'geographical',
          title: "系统功能设置",
          content: RoutesGroup.ManageName
        },
        component: () => import('@/views/Management/geographical')
      },

      {
        name: "LargeScreenHome",
        path: 'LargeScreenSetting/LargeScreenHome',
        meta: {
          setIndex: "Management",
          subname: 'LargeScreenHome',
          title: "首页设置",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/LargeScreenHome')
      },
        {
          name: "Cooperate",
          path: 'LargeScreenSetting/Cooperate',
          meta: {
            setIndex: "Management",
            subname: 'Cooperate',
            title: "互联共建设置",
            content: RoutesGroup.LargeScreenSetting
          },
          component: () => import('@/views/Management/Domesticsetting/Cooperate')
        },
        {
          name: "JointConstruction",
          path: 'LargeScreenSetting/JointConstruction',
          meta: {
            setIndex: "Management",
            subname: 'JointConstruction',
            title: "联建列表",
            content: RoutesGroup.LargeScreenSetting
          },
          component: () => import('@/views/Management/Domesticsetting/JointConstruction')
        },
        {
          name: "JointConstructionDetail",
          path: 'LargeScreenSetting/JointConstruction/detail',
          meta: {
            setIndex: "Works",
            subname: 'JointConstruction',
            title: "联建列表详情",
            content: RoutesGroup.LargeScreenSetting
          },
          component: () => import('@/views/Management/Domesticsetting/JointConstruction/detail'),
        },
      {
        name: "Devprocess",
        path: 'LargeScreenSetting/Devprocess',
        meta: {
          setIndex: "Management",
          subname: 'Devprocess',
          title: "发展历程",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/Devprocess/index'),
      },
      {
        name: "Typicalcases",
        path: 'LargeScreenSetting/Typicalcases',
        meta: {
          setIndex: "Management",
          subname: 'Typicalcases',
          title: "典型案例",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/Typicalcases/index'),
      },
      {
        name: "Honor",
        path: 'LargeScreenSetting/Honor',
        meta: {
          setIndex: "Management",
          subname: 'Honor',
          title: "荣誉展示",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/Honor/index'),
      },
      {
        name: "PMDemonstration",
        path: 'LargeScreenSetting/PMDemonstration',
        meta: {
          setIndex: "Management",
          subname: 'PMDemonstration',
          title: "党员示范岗",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/PMDemonstration/index'),
      },
      {
        name: "HeroineDemonstration",
        path: 'LargeScreenSetting/HeroineDemonstration',
        meta: {
          setIndex: "Management",
          subname: 'HeroineDemonstration',
          title: "巾帼示范岗",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/HeroineDemonstration/index'),
      },
        {
          name: "GRDemonstration",
          path: 'LargeScreenSetting/GRDemonstration',
          meta: {
            setIndex: "Management",
            subname: 'GRDemonstration',
            title: "工人示范岗",
            content: RoutesGroup.LargeScreenSetting
          },
          component: () => import('@/views/Management/Domesticsetting/GRDemonstration/index'),
        },
        {
          name: "TYDemonstration",
          path: 'LargeScreenSetting/TYDemonstration',
          meta: {
            setIndex: "Management",
            subname: 'TYDemonstration',
            title: "团员示范岗",
            content: RoutesGroup.LargeScreenSetting
          },
          component: () => import('@/views/Management/Domesticsetting/TYDemonstration/index'),
        },
      {
        name: "building",
        path: 'LargeScreenSetting/building',
        meta: {
          setIndex: "Management",
          subname: 'building',
          title: "党建风采",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/building/index'),
      },
      {
        name: "Feature",
        path: 'LargeScreenSetting/Feature',
        meta: {
          setIndex: "Management",
          subname: 'Feature',
          title: "特色亮点",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/Feature/index'),
      },
      {
        name: "FeatureVideo",
        path: 'LargeScreenSetting/FeatureVideo',
        meta: {
          setIndex: "Management",
          subname: 'FeatureVideo',
          title: "特色视频亮点",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/FeatureVideo/index'),
      },
      {
        name: "FounderInfo",
        path: 'LargeScreenSetting/FounderInfo',
        meta: {
          setIndex: "Management",
          subname: 'FounderInfo',
          title: "组织架构设置",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/FounderInfo'),
      },
      {
        name: "WebsiteData",
        path: 'LargeScreenSetting/WebsiteData',
        meta: {
          setIndex: "Management",
          subname: 'WebsiteData',
          title: "数据抓取",
          content: RoutesGroup.LargeScreenSetting
        },
        component: () => import('@/views/Management/Domesticsetting/WebsiteData'),
      },
        // {
        //   name: "LargeScreenAchievement",
        //   path: 'LargeScreenSetting/LargeScreenAchievement',
        //   meta: {
        //     setIndex: "Management",
        //     subname: 'LargeScreenAchievement',
        //     title: "党建成果设置",
        //     content: RoutesGroup.LargeScreenSetting
        //   },
        //   component: () => import('@/views/Management/Domesticsetting/LargeScreenAchievement'),
        // }
      ]
    }]
  },
  {
    path: '/',
    component: layout,
    children: [{
      name: 'MailList',
      path: '/MailList',
      component: MailList,
      meta: {
        setIndex: "MailList",
        title: "通讯录"
      }
    }],
  },

  {
    path: '/',
    component: layout,
    children: [{
      name: 'DataBank',
      path: '/DataBank',
      component: DataBank,
      meta: {
        setIndex: 6,
        title: "资料库"
      }
    }],
  }
]


export default new Router({
  routes: fixedRouter
})



// WEBPACK FOOTER //
// ./src/router/index.js